

import React from 'react';
import { Logo } from './Logo';
import { NavItem } from './NavItem';
import { NAVIGATION_ITEMS } from '../constants';
import { useAuth } from '../hooks/useAuth';
import { LogoutIcon } from './icons/LogoutIcon';
import { ChevronDoubleLeftIcon } from './icons/ChevronDoubleLeftIcon';
import { ChevronDoubleRightIcon } from './icons/ChevronDoubleRightIcon';
import { UserCircleIcon } from './icons/UserCircleIcon';


interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const { user, logout } = useAuth();

  if (!user) return null;

  const filteredNavItems = NAVIGATION_ITEMS.filter(item => 
    !item.allowedRoles || item.allowedRoles.includes(user.role)
  );

  return (
    <div
      className={`fixed inset-y-0 left-0 bg-white dark:bg-dark-secondary text-gray-600 dark:text-dark-text-secondary shadow-lg transform transition-all duration-300 ease-in-out z-30 flex flex-col
                  ${isOpen ? 'w-64' : 'w-20'}`}
    >
      <div className={`flex items-center ${isOpen ? 'justify-start' : 'justify-center'} h-16 border-b border-gray-200 dark:border-dark-tertiary`}>
        <Logo isSidebarOpen={isOpen} className={`${isOpen ? 'px-3' : ''}`} />
      </div>

      <nav className="flex-grow px-2 py-4 space-y-1 overflow-y-auto">
        <ul>
          {filteredNavItems.map((item) => (
            <NavItem key={item.name} item={item} isSidebarOpen={isOpen} />
          ))}
        </ul>
      </nav>

      <div className="mt-auto p-2 border-t border-gray-200 dark:border-dark-tertiary">
          {/* User Profile Area */}
          <div title={isOpen ? "" : user.email} className={`flex items-center p-3 my-1 rounded-lg ${isOpen ? '' : 'justify-center'}`}>
              {user.avatarUrl ? (
                  <img src={user.avatarUrl} alt="User avatar" className={`h-8 w-8 rounded-full object-cover flex-shrink-0 ${isOpen ? 'mr-3' : ''}`} />
              ) : (
                  <UserCircleIcon className={`text-4xl text-gray-500 dark:text-dark-text-secondary flex-shrink-0 ${isOpen ? 'mr-3' : ''}`} />
              )}
              {isOpen && (
                  <div className="overflow-hidden">
                      <p className="text-sm font-medium text-gray-900 dark:text-dark-text-primary truncate" title={user.name}>{user.name}</p>
                      <p className="text-xs text-gray-500 dark:text-dark-text-secondary truncate" title={user.email}>{user.email}</p>
                  </div>
              )}
          </div>

          <button
            onClick={toggleSidebar}
            className={`w-full flex items-center p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-tertiary transition-colors duration-200 ease-in-out text-gray-600 dark:text-dark-text-secondary hover:text-gray-900 dark:hover:text-dark-text-primary
                        ${isOpen ? 'justify-start' : 'justify-center'}`}
            title={isOpen ? 'Recolher menu' : "Expandir menu"}
          >
            {isOpen ? (
              <>
                <ChevronDoubleLeftIcon className="text-2xl mr-3" />
                <span className="text-sm font-medium whitespace-nowrap">Recolher</span>
              </>
            ) : (
              <ChevronDoubleRightIcon className="text-2xl" />
            )}
          </button>
          <button
            onClick={logout}
            className={`w-full flex items-center p-3 mt-1 rounded-lg hover:bg-red-500 hover:text-white transition-colors duration-200 ease-in-out text-gray-600 dark:text-dark-text-secondary
                        ${isOpen ? 'justify-start' : 'justify-center'}`}
            title={isOpen ? 'Sair' : "Sair"}
          >
            <LogoutIcon className={`text-2xl flex-shrink-0 ${isOpen ? 'mr-3' : ''}`} />
            {isOpen && <span className="text-sm font-medium whitespace-nowrap">Sair</span>}
          </button>
      </div>
    </div>
  );
};